import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Spinner } from 'reactstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import projectsActions from './actions'

const ProjectLogoEditor = ({
  dispatch,
  logoDataUrl = null,
  projectId,
  refreshLogoStatus = 'idle'
}) => {
  const { t } = useTranslation(['ProjectsPage'])
  const [isRefreshing, setIsRefreshing] = useState(false)

  const handleRefreshLogo = () => {
    setIsRefreshing(true)
    dispatch(projectsActions.refreshLogo(projectId))
  }

  useEffect(() => {
    if (isRefreshing && refreshLogoStatus !== 'refreshing') {
      setIsRefreshing(false)
    }
  }, [refreshLogoStatus, isRefreshing])

  const overlayClass = `project-logo-editor__overlay${
    isRefreshing ? ' project-logo-editor__overlay--hidden' : ''
  }`

  return (
    <div
      className="project-logo-editor"
      onClick={handleRefreshLogo}
      title={t('ProjectEditModal.refreshLogoTooltip')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleRefreshLogo()}
    >
      {logoDataUrl ? (
        <img
          src={logoDataUrl}
          alt=""
          className="project-logo-editor__image"
        />
      ) : (
        <i className="fa fa-image project-logo-editor__placeholder" />
      )}

      <div className={overlayClass}>
        <i className="fa fa-sync text-white" />
      </div>

      {isRefreshing && (
        <div className="project-logo-editor__spinner-overlay">
          <Spinner size="sm" color="primary" />
        </div>
      )}
    </div>
  )
}

ProjectLogoEditor.propTypes = {
  dispatch: PropTypes.func.isRequired,
  logoDataUrl: PropTypes.string,
  projectId: PropTypes.string.isRequired,
  refreshLogoStatus: PropTypes.string
}

const mapStateToProps = ({
  projects: {
    refreshLogoStatus
  }
}) => ({
  refreshLogoStatus
})

export default connect(mapStateToProps)(ProjectLogoEditor)
